
import './cartBox.css'
import { useNavigate } from 'react-router-dom';
import { currentStatusEnvois, historyCases, NatureEnvois, statusEnvois, typeEnvois, wilayas } from '../../data';
import { setPageNumber } from '../../context/envoieContext/apiCalls';

function CartBox({ idHistory, history, page, dispatch }) {
    const navigate = useNavigate();

    const actionHandler = () => {
        setPageNumber(dispatch, page);
        navigate(`/envois/detail/${idHistory}`)
    }

    const getTypeClass = (typeCode) => {
        if (typeCode === 1) {
            return "nwe"
        } else if (typeCode === 2) {
            return "livre"
        } else if (typeCode === 3) {
            return "retour"
        } else {
            return "annule"
        }
    }
     const getStatusClass = (statusCode) => {
        if (statusCode === 10) {
            return "preparation"
        } else if (statusCode === 1) {
            return "ramassage"
        } else if (statusCode === 8) {
            return "reception-agence"
        } else if (statusCode === 2) {
            return "depot-agence"
        } else if (statusCode === 3) {
            return "acheminement-depart"
        } else if (statusCode === 4) {
            return "acheminement-arrive"
        } else if (statusCode === 5) {
            return "livraison-domicile"
        } else if (statusCode === 6) {
            return "livraison-agence"
        } else if (statusCode === 9) {
            return "stock-agence"
        } else if (statusCode === 11) {
            return "retour-client"
        } else if (statusCode === 12) {
            return "livre"
        } else {
            return "stock-agence"
        }
    }
    
    const getTypeEnvoie = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        }
    }

    return (
        <div className='cart-box'>
            {
                history.Envoi.dead === 1 && (
                    <span className="material-symbols-rounded" style={{ color: "#00c02c", position: "absolute", top: "10px", right: " 10px" }}>lock</span>
                )
            }
            <div className="title-cart-1">
                <span className={`table-special ${getTypeClass(history.currentStatus)}`}>{currentStatusEnvois.filter(item => item.id === history.currentStatus)[0]['nom']}-{history.Envoi.tracking}</span>  <br />
                <span style={{ display: "inline-block", margin: "5px 0", }} className={`table-special ${getStatusClass(history.type)}`}>{statusEnvois.filter(item => item.id === history.type)[0]['nom']}</span>
            </div>
            <div className="content-cart">
                {    // ACC or RETOUR
                    (history.type === 5 && (history.currentStatus === 2 || history.currentStatus === 3 || history.currentStatus === 4)) ? (
                        <>
                            <div className="line" style={{ margin: "5px 0" }}>
                                <span>Type :</span>
                                <span className={`table-special-border ${getTypeEnvoie(history.Envoi.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === history.Envoi.typeEnvoie)[0]['nom']}</span>
                            </div>
                            <div className="line">
                                <span>Nom :</span>
                                <span>{history.Envoi.Entreprise ? history.Envoi.Entreprise.nom : history.Envoi.User.Userinfo.nom}</span>
                            </div>
                            <div className="line">
                                <span>Wilaya :</span>
                                <span>{wilayas.filter(item => item.id === history.Envoi.wilayaDeparture)[0]['nom']}</span>
                            </div>
                            <div className="line">
                                <span>Adresse :</span>
                                <span>{history.Envoi.addressDeparture || ""}</span>
                            </div>
                            <div className="line">
                                <span>Tel :</span>
                                <span>{history.Envoi.Entreprise ? history.Envoi.Entreprise.tel1 : history.Envoi.User.Userinfo.tel1}</span>
                            </div>
                            <div className="line">
                                <span>Nature :</span>
                                <span>{NatureEnvois.filter(item => item.id === history.Envoi.nature)[0]['nom']}</span>
                            </div>
                            <div className="line">
                                <span>Poids :</span>
                                <span>{history.Envoi.weight ? `${history.Envoi.weight} KG` : ""}</span>
                            </div>
                            <div className="line">
                                <span>Cout :</span>
                                <span>0.00 DA</span>
                            </div>
                            <div className="line">
                                <span>Date :</span>
                                <span>{history.createdAt.slice(0, 10)}</span>
                            </div>
                            {
                                history.Casehistories.length > 0 && (
                                    <div className="line">
                                        <span className={(history.Casehistories[0].type === 1 || history.Casehistories[0].type === 4) ? 'on' : 'off'}>{historyCases.filter(item => item.id === history.Casehistories[0].type)[0]['nom']}</span>
                                    </div>
                                )
                            }
                        </>
                    ) :
                        // pour ramassage
                        ((history.type === 1 && history.Envoi.typeEnvoie !== 3) || (history.type === 5 && history.Envoi.typeEnvoie === 3)) ? (
                            <>
                                <div className="line" style={{ margin: "5px 0" }}>
                                    <span>Type :</span>
                                    <span className={`table-special-border ${getTypeEnvoie(history.Envoi.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === history.Envoi.typeEnvoie)[0]['nom']}</span>
                                </div>
                                <div className="line">
                                    <span>Nom :</span>
                                    <span>{history.Envoi.Entreprise ? history.Envoi.Entreprise.nom : history.Envoi.User.Userinfo.nom}</span>
                                </div>
                                <div className="line">
                                    <span>Wilaya :</span>
                                    <span>{wilayas.filter(item => item.id === history.Envoi.wilayaDeparture)[0]['nom']}</span>
                                </div>
                                <div className="line">
                                    <span>Adresse :</span>
                                    <span>{history.Envoi.addressDeparture || ""}</span>
                                </div>
                                <div className="line">
                                    <span>Tel :</span>
                                    <span>{history.Envoi.Entreprise ? history.Envoi.Entreprise.tel1 : history.Envoi.User.Userinfo.tel1}</span>
                                </div>
                                <div className="line">
                                    <span>Nature :</span>
                                    <span>{NatureEnvois.filter(item => item.id === history.Envoi.nature)[0]['nom']}</span>
                                </div>
                                <div className="line">
                                    <span>Poids :</span>
                                    <span>{history.Envoi.weight ? `${history.Envoi.weight} KG` : ""}</span>
                                </div>
                                <div className="line">
                                    <span>Cout :</span>
                                    {
                                        history.Envoi.Entreprise ? (<span>0.00 DA</span>)
                                            : <span>
                                                {
                                                    (history.type === 1 && history.Envoi.typeEnvoie !== 3) && (
                                                        history.Envoi.cost ? `${Number.parseFloat(history.Envoi.cost).toFixed(2)} DA + ${Number.parseFloat(history.cost).toFixed(2)} DA de ramassage`
                                                            : ""
                                                    )
                                                }
                                                {
                                                    (history.type === 5 && history.Envoi.typeEnvoie === 3) && (
                                                        history.Envoi.cost ? `${Number.parseFloat(history.Envoi.cost).toFixed(2)} DA + ${Number.parseFloat(history.cost).toFixed(2)} DA de livraison domicile`
                                                            : ""
                                                    )
                                                }
                                            </span>
                                    }
                                </div>
                                <div className="line">
                                    <span>Date :</span>
                                    <span>{history.createdAt.slice(0, 10)}</span>
                                </div>
                                {
                                    history.Casehistories.length > 0 && (
                                        <div className="line">
                                            <span className={(history.Casehistories[0].type === 1 || history.Casehistories[0].type === 4) ? 'on' : 'off'}>{historyCases.filter(item => item.id === history.Casehistories[0].type)[0]['nom']}</span>
                                        </div>
                                    )
                                }
                            </>
                        )
                            :   // pour la livraison
                            ((history.type === 1 && history.Envoi.typeEnvoie === 3) || (history.type === 5 && history.Envoi.typeEnvoie !== 3)) ? (
                                <>
                                    <div className="line" style={{ margin: "5px 0" }}>
                                        <span>Type :</span>
                                        <span className={`table-special-border ${getTypeEnvoie(history.Envoi.typeEnvoie)}`}>{typeEnvois.filter(item => item.id === history.Envoi.typeEnvoie)[0]['nom']}</span>
                                    </div>
                                    <div className="line">
                                        <span>Nom :</span>
                                        <span>{history.Envoi.nomArrived}</span>
                                    </div>
                                    <div className="line">
                                        <span>Wilaya :</span>
                                        <span>{wilayas.filter(item => item.id === history.Envoi.wilayaArrived)[0]['nom']}</span>
                                    </div>
                                    <div className="line">
                                        <span>Adresse :</span>
                                        <span>{history.Envoi.addressArrived || ""}</span>
                                    </div>
                                    <div className="line">
                                        <span>Tel :</span>
                                        <span>{history.Envoi.tel1Arrived || ""}</span>
                                    </div>
                                    <div className="line">
                                        <span>Nature :</span>
                                        <span>{NatureEnvois.filter(item => item.id === history.Envoi.nature)[0]['nom']}</span>
                                    </div>
                                    <div className="line">
                                        <span>Poids :</span>
                                        <span>{history.Envoi.weight ? `${history.Envoi.weight} KG` : ""}</span>
                                    </div>
                                    <div className="line">
                                        <span>Montant :</span>
                                        <span>{history.Envoi.montant ? `${Number.parseFloat(history.Envoi.montant).toFixed(2)} DA` : ""}</span>
                                    </div>
                                    <div className="line">
                                        <span>Date :</span>
                                        <span>{history.createdAt.slice(0, 10)}</span>
                                    </div>
                                    {
                                        history.Casehistories.length > 0 && (
                                            <div className="line">
                                                <span className={(history.Casehistories[0].type === 1 || history.Casehistories[0].type === 4) ? 'on' : 'off'}>{historyCases.filter(item => item.id === history.Casehistories[0].type)[0]['nom']}</span>
                                            </div>
                                        )
                                    }
                                </>
                            ) : ""
                }

                {
                    history.Envoi.dead !== 1 && (
                        <div className='button'>
                            <span onClick={actionHandler}>Action</span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default CartBox
